import type { ReactNode } from 'react';

export type CalloutTone = 'info' | 'success' | 'warning' | 'danger';

interface CalloutProps {
  readonly tone?: CalloutTone;
  readonly title?: ReactNode;
  readonly children: ReactNode;
}

/**
 * Aviso destacado. Los de tono `danger` se anuncian como alerta para que un
 * lector de pantalla los lea en cuanto aparecen.
 */
export function Callout({ tone = 'info', title, children }: CalloutProps) {
  return (
    <div
      className={`qr-callout qr-callout--${tone}`}
      role={tone === 'danger' ? 'alert' : 'status'}
    >
      {title ? <strong className="qr-callout__title">{title}</strong> : null}
      <div>{children}</div>
    </div>
  );
}
